import * as types from "../actions/actionTypes";

const initialState = {
  view: "letter"
};

const commandReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.COMMAND_CHANGE_VIEW:
      return { ...state, view: action.view };
    default:
      return state;
  }
};

export default commandReducer;



// WEBPACK FOOTER //
// ./src/reducers/commandReducer.js